// extracted by mini-css-extract-plugin
export default {"otp-wrapper":"AddEmail_otp-wrapper__tFpl3"};